import { SaveActionButtonsComponent } from '../../../components/save-action-buttons/save-action-buttons.component';
import { SaveActionButton } from '../../../components/save-action-buttons/save-action-button.model';
import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbDropdownModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { Component, computed, inject, Injector, OnInit, Signal, ViewChild } from '@angular/core';
import {
  CreateUpdateSupplierReturnNoteDto,
  DayBookService,
  SupplierReturnNoteDefaultValueDto,
  SupplierReturnNoteDto,
  SupplierReturnNoteService,
  SupplierReturnStatus,
} from '@digiwall/goliath-documents/proxy';
import {
  AnnexesListComponent,
  CurrentCompanyStore,
  GoliathCoreEnumerationTypeStore,
} from '@digiwall/goliath-core';
import {
  LocalizationModule,
  SubscriptionService,
  ConfigStateService,
  LocalizationService,
} from '@abp/ng.core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  AbstractControl,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';

import {
  ChatComponent,
  conditionalValidator,
  DeactivatableComponentService,
  DwReadonlyFormDirective,
  NewId,
  OdysseyOffcanvas,
} from '@digiwall/core';
import {
  CounterComponent,
  DropdownMenu,
  DropdownMenuComponent,
  OrderByPipe,
  PanelComponent,
} from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import { DwNavLinkDirective } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwKeyboardShortcutDirective } from '@digiwall/core';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoSizedDropdownDirective } from '@digiwall/ui-kit';
import { ErrorFormControlDirective } from '@digiwall/core';
import { DwInputRequiredDirective } from '@digiwall/core';
import { DwDatePickerComponent } from '@digiwall/core';
import { DwInputAutoCompleteDirective } from '@digiwall/core';
import { DocConditionsComponent } from '../../base-docs/detail/doc-conditions/doc-conditions.component';
import { DocClassificationsComponent } from '../../base-docs/detail/doc-classifications/doc-classifications.component';
import { CommonModule } from '@angular/common';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { BaseSupplierDocDetail } from '../../base-supplier-docs/base-supplier-doc-detail';
import { ClassificationTypeService, DocRole, WeightUnit } from '@digiwall/goliath-core/proxy';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SupplierService } from '@digiwall/goliath-contacts/proxy';
import { GoliathContactsEnumerationTypeStore, SalesPersonStore } from '@digiwall/goliath-contacts';
import { DocSupplierOthersComponent } from '../../base-docs/detail/doc-supplier-others/doc-supplier-others.component';
import { SupplierReturnNoteLinesEditorComponent } from './supplier-return-note-lines/supplier-return-note-lines-editor.component';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { EnumerationTypeDto } from '@digiwall/core/proxy';
import { Observable } from 'rxjs';
import { BaseStockDocDetailHelperService } from '../../base-docs/detail/base-stock-doc-detail';
import { DocSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-side-panel/doc-side-panel.component';
import {
  DocNumberTagComponent,
  DocumentCoreCardComponent,
  DocumentSupplierCardComponent,
  SupplierDocumentDateCardComponent,
  SupplierDocumentStatusCardComponent,
} from '../../../components';
import { StockValidationSharedLogicService } from '../../stock-validation-shared-logics/stock-validation-shared-logic.service';
import moment from 'moment';

@Component({
  selector: 'document-supplier-return-note-detail',
  templateUrl: './supplier-return-note-detail.component.html',
  styleUrl: './supplier-return-note-detail.component.scss',
  providers: [
    BaseStockDocDetailHelperService,
    DocTemplateService,
    SubscriptionService,
    StockValidationSharedLogicService,
  ],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    NgSelectComponent,
    AutoSizedDropdownDirective,
    ErrorFormControlDirective,
    DwInputRequiredDirective,
    DwDatePickerComponent,
    DwInputAutoCompleteDirective,
    DocConditionsComponent,
    DocClassificationsComponent,
    DocSupplierOthersComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    DropdownMenuComponent,
    NgbNavOutlet,
    SaveActionButtonsComponent,
    SidePanelComponent,
    FormsModule,
    CounterComponent,
    LocalizationModule,
    SupplierReturnNoteLinesEditorComponent,
    DwReadonlyFormDirective,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DocSidePanelComponent,
    DocumentCoreCardComponent,
    SupplierDocumentDateCardComponent,
    DocumentSupplierCardComponent,
    SupplierDocumentStatusCardComponent,
    OrderByPipe,
    DocNumberTagComponent,
  ],
})
export class SupplierReturnNoteDetailComponent
  extends BaseSupplierDocDetail<
    SupplierReturnNoteService,
    SupplierReturnNoteDto,
    CreateUpdateSupplierReturnNoteDto,
    SupplierReturnNoteDefaultValueDto
  >
  implements OnInit
{
  @ViewChild('supplierReturnNoteLineGrid') docLineGrid: any;

  protected _document: SupplierReturnNoteDto;
  public get document() {
    return this.entity;
  }

  public get saveFromExtends() {
    return super.save;
  }

  public get afterSaveFromExtends() {
    return super.afterSave;
  }

  public get navigateAfterSaveFromExtends() {
    return super.navigateAfterSave;
  }

  currentCompanyStore = inject(CurrentCompanyStore);
  enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  contactEnumerationTypeStore = inject(GoliathContactsEnumerationTypeStore);
  coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  salesPersonStore = inject(SalesPersonStore);
  stockValidationSharedLogicService = inject(StockValidationSharedLogicService);

  weightUnits = WeightUnit;

  docRole = DocRole.SupplierReturnNote;
  SupplierReturnStatus = SupplierReturnStatus;

  private validateInProgress: boolean = false;

  get newId() {
    return NewId;
  }

  actions: Signal<DropdownMenu> = computed(() => ({
    groups: [this.baseActionsThirdPartyDoc()],
  }));

  protected saveActionBtns = computed((): SaveActionButton[] => [
    {
      label: this.localizationService.instant('::Save'),
      action: () => this.save(),
      disabled: () =>
        this.entitySignal()?.returnStatus == SupplierReturnStatus.Closed ||
        !this.form.dirty ||
        !this.stockValidationSharedLogicService.canSave(),
    },
  ]);

  protected disabledValidate() {
    return (
      this.isCreationMode() ||
      this.lineCount() == 0 ||
      this.entity.returnStatus == SupplierReturnStatus.Closed
    );
  }

  protected isCreationMode = computed(
    () => this.entitySignal()?.id == NewId || this.entitySignal()?.id == null,
  );

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    supplierReturnNoteService: SupplierReturnNoteService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    injector: Injector,
    supplierService: SupplierService,
    config: ConfigStateService,
    docTemplateService: DocTemplateService,
    classificationTypeService: ClassificationTypeService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
    private stockHelper: BaseStockDocDetailHelperService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      supplierReturnNoteService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      supplierService,
      config,
      confirmationService,
      deactivableComponentService,
    );
    stockHelper.Doc = this;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.stockValidationSharedLogicService.setup({
      isCreationMode: this.isCreationMode,
      isValidated: this.isValidated,
      lineCount: this.lineCount,
      isStockValidated: computed(() => {
        const entity = this.entitySignal();
        return this.isStockValidated() && entity.returnStatus == SupplierReturnStatus.Closed;
      }),
    });
    this.init();
  }

  override get formModel() {
    return Object.assign({}, super.formModel, {
      returnedDate: [
        null,
        conditionalValidator(
          () => this.form.get('documentDate')?.value,
          (control: AbstractControl): ValidationErrors | null => {
            const docDate = this.form?.get('documentDate')?.value;
            const deliveryDate = control.value;
            if (!docDate || !deliveryDate) return null;
            return moment(deliveryDate).isSameOrBefore(docDate, 'day')
              ? null
              : {
                  invalidDate: false,
                };
          },
          () => {
            return [this.form.get('documentDate').valueChanges];
          },
        ),
      ],
      returnStatus: [null, Validators.required],
    });
  }

  protected supplierReturnStatus(): EnumerationTypeDto[] {
    if (this.entity?.returnStatus === SupplierReturnStatus.Closed) {
      return this.enumerationTypeStore.supplierReturnStatus();
    }
    return this.enumerationTypeStore
      .supplierReturnStatus()
      .filter(status => status.uniqueCode != SupplierReturnStatus.Closed);
  }

  override saveRequest(): Observable<SupplierReturnNoteDto> {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.form.disabled) return;

    let formValue = this.form.value as CreateUpdateSupplierReturnNoteDto;

    const request = this.entity.id
      ? this.docService.update(this.entity.id, formValue)
      : this.docService.create(formValue);

    return request as Observable<SupplierReturnNoteDto>;
  }

  protected override async afterGetEntity(response: SupplierReturnNoteDto): Promise<void> {
    await super.afterGetEntity(response);
    this.subscribeToFormValueChanges();
  }

  protected override afterSave(): void {
    super.afterSave();
    if (this.validateInProgress) {
      this.docService.validateStock(this.entity.id).subscribeOnce(() => {
        this.refreshEntity();
        this.validateInProgress = false;
        this.toastService.success('Doc::CustomerQuote:IsValidated');
      });
    } else {
      this.subscribeToFormValueChanges();
    }
  }

  protected validateStock() {
    this.validateInProgress = true;
    this.save();
  }

  public override canDeactivate = async () => {
    this.canDeactivateTitle = this.stockValidationSharedLogicService.getCanDeactivateTitle();
    return !this.form.dirty;
  };
}
